module.exports = __webpack_public_path__ + "assets/131618d3c0c58786947ace5ceda5d8c2.png";